import { useState } from 'react';
import { useCurrentUser, useSetPersonLink } from '../lib/me.js';
import { usePeople } from '../lib/people.js';
import { PersonAvatar } from './PersonAvatar.js';
import { PersonPicker } from './PersonPicker.js';

/**
 * "This is me" — links the signed-in login to a person record
 * (Settings → Account). Once set, the app knows which person you are:
 * a You badge on your row and card, and a "Me" shortcut at the top of
 * every person picker. Per-user and synced, like the home layout.
 */
export function ThisIsMeSection() {
  const me = useCurrentUser();
  const people = usePeople();
  const setLink = useSetPersonLink();
  const [picking, setPicking] = useState(false);

  const linked = me.data?.personId
    ? people.data?.find((p) => p.id === me.data.personId)
    : undefined;

  return (
    <div className="field">
      <span className="field__label">This is me</span>
      {linked && !picking ? (
        <div className="me-link">
          <PersonAvatar person={linked} className="me-link__av" />
          <span className="me-link__mid">
            <span className="me-link__name">{linked.displayName}</span>
            <span className="me-link__sub">Your person record</span>
          </span>
          <button
            type="button"
            className="btn btn--secondary btn--small"
            onClick={() => setPicking(true)}
          >
            Change
          </button>
        </div>
      ) : (
        <PersonPicker
          value={me.data?.personId ?? null}
          onChange={(id) => {
            setLink.mutate(id);
            setPicking(false);
          }}
          placeholder="Pick yourself from People…"
          autoFocus={picking}
        />
      )}
      <span className="field__hint">
        Tells the app which person record is you — you get a You badge and a &ldquo;Me&rdquo;
        shortcut in every person picker. Pick from existing people or type your name to add
        yourself.
      </span>
    </div>
  );
}
